// Function to add ARIA attributes to p tags and set up describedby relationship
function addAriaAttributes(element, descriptionElement) {
  // Get the element's ID and create a description ID
  const elementId = element.getAttribute('id');
  if (!elementId) return; // Skip if element has no ID
  
  const descriptionId = `${elementId}-description`;
  
  // Add attributes to description element
  descriptionElement.setAttribute('id', descriptionId);
  
  // Add aria-live and aria-atomic only for textarea descriptions
  if (element.tagName === 'TEXTAREA') {
    descriptionElement.setAttribute('aria-live', 'polite');
    descriptionElement.setAttribute('aria-atomic', 'true');
  }
  
  // Add aria-describedby to the element
  element.setAttribute('aria-describedby', descriptionId);
}

// Function to check and process the infinite options block
function processInfiniteOptionsBlock() {
  // Find the product info container
  const productInfoContainer = document.querySelector('.product__info-container');
  if (!productInfoContainer) return;

  // Find the infinite options block
  const infiniteOptionsBlock = productInfoContainer.querySelector('.shopify-block[id*="infinite_options_app_block"]');
  if (!infiniteOptionsBlock) return;

  // Find all textareas with maxlength attribute and inputs
  const formElements = infiniteOptionsBlock.querySelectorAll('textarea[maxlength], input');
  
  // For each element, find its sibling description element
  formElements.forEach(element => {
    const nextSibling = element.nextElementSibling;
    
    // Check if the next sibling is either a p tag or a div
    if (nextSibling && (nextSibling.tagName === 'P' || nextSibling.tagName === 'DIV')) {
      addAriaAttributes(element, nextSibling);
    }
  });
}

// Create a MutationObserver to watch for changes
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length) {
      processInfiniteOptionsBlock();
    }
  });
});

// Start observing the document body for changes
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Initial check in case the form is already present
document.addEventListener('DOMContentLoaded', processInfiniteOptionsBlock);
